import { render, staticRenderFns } from "./SearchDeferredWorkPage.vue?vue&type=template&id=298db112&"
import script from "./SearchDeferredWorkPage.vue?vue&type=script&lang=js&"
export * from "./SearchDeferredWorkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports